import { ReportFeatures } from '@hcs/types';

export const FORECAST_CHART_FEATURES = [
  ReportFeatures.SubjectForecastBlock,
  ReportFeatures.SubjectForecastZipcode,
];
